import { call, put, takeEvery } from "redux-saga/effects";
import {
  createHeaderRequest,
  createHeaderSuccess,
  createHeaderFailure,
} from "../slice/renameTitleSlice";
import { updateTiteSession } from "../../api/apiService";

interface CreateHeaderRequest {
    id: string;              // header parameter
    body: {
      header: string;
    };
  }

export function* renameSaga(
  action: { payload: CreateHeaderRequest }
): Generator<any, void, any> {
  try {
    const response = yield call(updateTiteSession, action.payload);
    yield put(createHeaderSuccess(response.data));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(createHeaderFailure(error.message));
    } else {
      yield put(createHeaderFailure("An unknown error occurred."));
    }
  }
}

export function* renameTitleSaga() {
  yield takeEvery(createHeaderRequest, renameSaga);
}
